module.exports = __webpack_public_path__ + "img/sdg6_id.6b4a8e8c.svg";